/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpSubnetPerRegion } from '../models/GcpSubnetPerRegion';

export class GcpNetworkConnectivityConfig {
  /**
  * Network name.
  */
  'network': string;
  /**
  * Subnets to configure for regions in the network. For regions not specified in this list, Eon attempts to use the default subnet. 
  */
  'subnetsPerRegion'?: Array<GcpSubnetPerRegion>;
  /**
  * Indicates whether the VPC network is a shared VPC. If true, `networkHostProject` must be specified. 
  */
  'isSharedVpc': boolean;
  /**
  * ID of the project that hosts the VPC network. Applicable for shared VPC network. 
  */
  'networkHostProject': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "network",
      "baseName": "network",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetsPerRegion",
      "baseName": "subnetsPerRegion",
      "type": "Array<GcpSubnetPerRegion>",
      "format": ""
    },
    {
      "name": "isSharedVpc",
      "baseName": "isSharedVpc",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "networkHostProject",
      "baseName": "networkHostProject",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpNetworkConnectivityConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

